var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2364 11.9933L11.2529 13.5128C11.2581 13.9268 11.5979 14.259 12.0111 14.2545C12.4251 14.25 12.7574 13.9103 12.7529 13.4963L12.7364 11.976C12.7319 11.562 12.3921 11.2298 11.9781 11.2343C11.5641 11.2395 11.2319 11.5793 11.2364 11.9933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2506 9.90225L8.2521 18.7492C8.25285 20.8177 9.92985 22.4955 11.9991 22.4955C12.9944 22.4955 13.9484 22.1002 14.6519 21.3967C15.3554 20.6932 15.7506 19.7392 15.7499 18.7447L15.7484 9.8895L17.8184 5.07825C17.9384 4.79925 18.0006 4.4985 18.0013 4.19475L18.0021 3.75525C18.0036 3.1575 17.7674 2.58375 17.3451 2.16075C16.9229 1.73775 16.3499 1.5 15.7521 1.5H8.2476C7.00635 1.5 5.99985 2.50425 5.9976 3.74475C5.99685 3.9105 5.99685 4.0635 5.9961 4.188C5.99535 4.49475 6.0576 4.79925 6.1791 5.08125L8.2506 9.90225ZM15.7903 5.99775H8.2056L9.6906 9.45375C9.7371 9.5625 9.7566 9.67575 9.7506 9.786L9.7521 18.7485C9.7521 19.9897 10.7586 20.9955 11.9991 20.9955C12.5961 20.9955 13.1691 20.7585 13.5914 20.3362C14.0129 19.914 14.2499 19.3417 14.2499 18.7447L14.2484 9.8475C14.2319 9.71775 14.2484 9.582 14.3031 9.45375L15.7903 5.99775ZM16.4354 4.49775L16.4406 4.48575C16.4804 4.39275 16.5014 4.29225 16.5014 4.191L16.5021 3.7515C16.5029 3.55275 16.4241 3.3615 16.2831 3.2205C16.1421 3.0795 15.9516 3 15.7521 3H8.2476C7.8336 3 7.49835 3.3345 7.4976 3.7485L7.4961 4.191C7.4961 4.29375 7.5171 4.395 7.5576 4.48875L7.5606 4.49775H16.4354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorchOff);
export default __webpack_public_path__ + "static/media/torch_off.2c8f0d799df23ff25d25cba4e470cc05.svg";
export { ForwardRef as ReactComponent };